



















import { Vue, Component, Prop } from "vue-property-decorator";

import DragNDrop, { FileInputType, FilesPayload } from "@share/common/form/form-controls/file/DragNDrop.vue";
import BounceSpinner from "@share/common/BounceSpinner.vue";
import ImportTemplateLink from "@share/participants-import/components/steps/step-1-upload/import-template-link/ImportTemplateLink.vue";

import { ProfileField } from "../../../../../types/ProfileField";
import { XLSXFileService } from "@share/common/services/xlsx/XLSXFileService/XLSXFileService";
import { sleep } from "@share/web-conferences/helpers/SleepHelper";

@Component({ components: { DragNDrop, ImportTemplateLink, BounceSpinner } })

export default class Step1Upload extends Vue {

    @Prop({ required: true }) XLSXFileService: XLSXFileService;
    @Prop({ required: true }) userProfileFields: ProfileField[];

    FileInputType = FileInputType;
    fileValue: FilesPayload = [];
    templateLink = "";
    fileValidationErrorText = "";

    requiredFields = [
        "phoneNumber",
        "email"
    ]

    loading = false;

    mounted() {
        this.createTemplate();
    }

    createTemplate() {
        this.templateLink = this.XLSXFileService.createTemplateFile(this.userProfileFields.map(field => field.name));
    }

    async upload(files: FilesPayload) {

        if(files) {
            this.loading = true;

            const file = Array.from(files)[0].file;

            if(file instanceof File) {

                if(file.size > 20971520) {
                    this.$emit("invalid", true);
                    this.fileValidationErrorText = this.$t("participants.import.validation.sizeLimit", { sizeMb: "20" }).toString();
                    this.loading = false;
                    return
                }

                let buffer = await file.arrayBuffer();

                try {

                    const data = this.XLSXFileService.getDataFromArrayBuffer<Record<string, string>>(buffer);

                    await sleep(700);

                    if(data.length) {

                        const isValid = this.validateFileData(data)

                        if(isValid) {
                            this.fileValidationErrorText = ""

                            this.$emit("uploaded", data.map(item => Object.freeze(item)));
                        }
                        else {
                            this.$emit("invalid", true);
                            this.fileValidationErrorText = this.$t("participants.import.validation.requiredFields").toString();
                        }
                    }
                    else {
                        this.$emit("invalid", true);
                        this.fileValidationErrorText = this.$t("participants.import.validation.noData").toString();
                    }
                }
                catch(e) {
                    this.$store.dispatch('reportException', e);
                }
                finally {
                    this.loading = false;
                }
            }
        }
    }

    validateFileData(data: Record<string, string>[]) {
        return !data.some(item => this.requiredFields.every((field) => !item[field]))
    }

    beforeDestroy() {
        this.XLSXFileService.revokeFileObject(this.templateLink);
    }
}

